import { render, staticRenderFns } from "./come-funziona-salabam.vue?vue&type=template&id=62912dda&"
import script from "./come-funziona-salabam.vue?vue&type=script&lang=js&"
export * from "./come-funziona-salabam.vue?vue&type=script&lang=js&"
import style0 from "./come-funziona-salabam.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports